<template>
  <div class="min-h-screen w-screen flex items-center justify-center">
    <div
      class="bg-white/95 backdrop-blur-sm w-full h-full pt-8"
      :class="borderClass"
    >
      <div class="flex flex-col items-center space-y-4">
        <!-- 加载状态图标 -->
        <div
          v-if="type === 'loading'"
          class="relative"
        >
          <div
            class="absolute inset-0 rounded-full blur-xl animate-pulse"
            :class="colorClasses.glow"
          />
          <i
            class="text-4xl animate-spin relative z-10"
            :class="[icon, colorClasses.icon]"
          />
        </div>

        <!-- 错误状态图标 -->
        <div
          v-else
          class="rounded-full p-4"
          :class="colorClasses.bg"
        >
          <i
            class="text-4xl"
            :class="[icon, colorClasses.icon]"
          />
        </div>

        <!-- 文字内容 -->
        <div
          v-if="title || message"
          class="text-center"
          :class="title ? 'space-y-2' : ''"
        >
          <h3
            v-if="title"
            class="text-gray-800 text-lg font-semibold"
          >
            {{ title }}
          </h3>
          <p
            v-if="message"
            class="text-gray-700 text-lg font-medium"
          >
            {{ message }}
          </p>
        </div>

        <!-- 错误详情 -->
        <div
          v-if="errorDetails"
          class="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200 max-w-full overflow-x-auto"
        >
          <pre class="text-xs text-gray-700 whitespace-pre-wrap break-words">{{ errorDetails }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
  name: 'StatusCard',
  props: {
    type: { type: String, required: true }, // 'loading' | 'error'
    icon: { type: String, required: true },
    color: { type: String, required: true }, // 'blue' | 'indigo' | 'yellow' | 'red'
    title: { type: [String, Object], default: '' },
    message: { type: [String, Object], default: '' },
    errorDetails: { type: String, default: '' },
    wide: { type: Boolean, default: false },
  },
  setup(props) {
    const colorClasses = computed(() => {
      const colors = {
        blue: {
          glow: 'bg-blue-400/20',
          icon: 'text-blue-500',
          bg: 'bg-blue-100',
        },
        indigo: {
          glow: 'bg-indigo-400/20',
          icon: 'text-indigo-500',
          bg: 'bg-indigo-100',
        },
        yellow: {
          glow: 'bg-yellow-400/20',
          icon: 'text-yellow-600',
          bg: 'bg-yellow-100',
        },
        red: {
          glow: 'bg-red-400/20',
          icon: 'text-red-600',
          bg: 'bg-red-100',
        },
      };
      return colors[props.color] || colors.blue;
    });

    const borderClass = computed(() => (props.color === 'red' ? 'border-red-100' : 'border-gray-100'));

    return {
      colorClasses,
      borderClass,
    };
  },
};
</script>
